import { render, staticRenderFns } from "./index.vue?vue&type=template&id=018a2c22"
import script from "./workflowEvent.js?vue&type=script&lang=js&external"
export * from "./workflowEvent.js?vue&type=script&lang=js&external"
import style0 from "./workflowEvent.css?vue&type=style&index=0&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports